var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.0036C6.10313 11.0036 7 10.0843 7 8.95356C7 7.82286 6.10313 6.90356 5 6.90356C3.89688 6.90356 3 7.82286 3 8.95356C3 10.0843 3.89688 11.0036 5 11.0036ZM19 11.0036C20.1031 11.0036 21 10.0843 21 8.95356C21 7.82286 20.1031 6.90356 19 6.90356C17.8969 6.90356 17 7.82286 17 8.95356C17 10.0843 17.8969 11.0036 19 11.0036ZM20 12.0286H18C17.45 12.0286 16.9531 12.256 16.5906 12.6243C17.85 13.3322 18.7438 14.6103 18.9375 16.1286H21C21.5531 16.1286 22 15.6705 22 15.1036V14.0786C22 12.9479 21.1031 12.0286 20 12.0286ZM7.40938 12.6243C7.04688 12.256 6.55 12.0286 6 12.0286H4C2.89688 12.0286 2 12.9479 2 14.0786V15.1036C2 15.6705 2.44688 16.1286 3 16.1286H5.05938C5.25625 14.6103 6.15 13.3322 7.40938 12.6243Z",
    fill: "#007283"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1172 12.175C14.0516 12.175 15.6172 10.5702 15.6172 8.5875C15.6172 6.60477 14.0516 5 12.1172 5C10.1828 5 8.61719 6.60477 8.61719 8.5875C8.61719 10.5702 10.1828 12.175 12.1172 12.175ZM14.5172 13.2H14.2578C13.6078 13.5203 12.8859 13.7125 12.1172 13.7125C11.3484 13.7125 10.6297 13.5203 9.97656 13.2H9.71719C7.72969 13.2 6.11719 14.8528 6.11719 16.89V17.8125C6.11719 18.6613 6.78906 19.35 7.61719 19.35H16.6172C17.4453 19.35 18.1172 18.6613 18.1172 17.8125V16.89C18.1172 14.8528 16.5047 13.2 14.5172 13.2Z",
    fill: "#00B0CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/Team.31348433683640ab9526a19e12be7faf.svg";
export { ForwardRef as ReactComponent };